module.exports = __webpack_public_path__ + "media/audio23.94397b76.mp3";